import Filters from "./sidebar/filters";
import Search from "./sidebar/search";
import Book from "./sidebar/book";
import Books from "../../../api/biblia/books";
import Chapter from "./content/chapter";
import AdvancedSearch from "./content/advanced-search";

export default class BibliaOnline {
	constructor() {
		this.books = new Book(this);
		this.chapter = new Chapter(this);
		this.filters = new Filters(this);
		this.search = new Search(this);
		this.advancedSearch = new AdvancedSearch(this);
		this.booksApi = new Books;

		this.initializeBooks();
	}

	async initializeBooks() {
		const list = document.querySelector('#biblia-online .list');
		if (list) {
			list.classList.add('loader');

			this.booksApi.getBooks()
			.then((data) => {
				if (data.body) {
					const body = data.body;
					this.books.setBooksData(body);
					body.forEach(item => this.books.createBook(list, item));

					this.filters.initialize();
					this.search.initialize();
					this.chapter.setChapter(body[0]);

					list.classList.remove('loader');

					this.advancedSearch.setBooksSelect(body);
				}
			})
			.catch(error => console.error('Error:', error));
		}
	}
}
